import { t } from "@lingui/macro";
import { SectionKey } from "@reactive-resume/schema";
import { Badge } from "@reactive-resume/ui";
import { useMemo } from "react";

import { useResumeStore } from "@/client/stores/resume";

type Props = { id: SectionKey };

export const ColumnBadge = ({ id }: Props) => {
  const layout = useResumeStore((state) => state.resume.data.metadata.layout);
  const setValue = useResumeStore((state) => state.setValue);

  const numCols = layout[0]?.length ?? 1;

  const currentCol = useMemo(() => {
    for (const page of layout) {
      for (let c = 0; c < page.length; c++) {
        if (page[c].includes(id)) return c;
      }
    }
    return 0;
  }, [layout, id]);

  if (numCols < 2) return null;

  const label = currentCol === 0 ? t`Main` : t`Side`;

  const toggle = () => {
    const newCol = currentCol === 0 ? 1 : 0;
    const layoutCopy: string[][][] = JSON.parse(JSON.stringify(layout));

    for (const page of layoutCopy) {
      for (let c = 0; c < page.length; c++) {
        page[c] = page[c].filter((s) => s !== id);
      }
    }

    layoutCopy[0][newCol].push(id);
    setValue("metadata.layout", layoutCopy);
  };

  return (
    <Badge
      variant="secondary"
      className="cursor-pointer select-none px-1.5 py-0 text-[10px] font-medium transition-colors hover:bg-secondary-accent"
      onClick={toggle}
    >
      {label}
    </Badge>
  );
};
